module.exports = __webpack_public_path__ + "static/media/2019_conf_Overcome_your_Innovation_Biases.65348daf.png";